import React, { useState, useEffect } from "react";
import { Input, TextAreaInput } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import { useFormikContext } from "formik";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import FileUploader from "../../Helpers/Dropzone/FileUploader";
import EditAttachments from "../../Helpers/Dropzone/EditAttachments";

const CompanyFormBody = ({ isEditing, editData }) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext();

  const [attachments, setAttachments] = useState(
    isEditing && editData?.data?.attachments ? editData.data.attachments : []
  );
  const [newAttachments, setNewAttachments] = useState(null);

  useEffect(() => {
    if (isEditing && editData?.data?.attachments) {
      setAttachments(editData.data.attachments);
    }
  }, [isEditing, editData]);

  const statusOptions = [
    { label: trans("ACTIVE"), value: "ACTIVE" },
    { label: trans("INACTIVE"), value: "INACTIVE" },
  ];

  const tradeOptions = [
    { label: trans("General Contractor"), value: "General Contractor" },
    { label: trans("Electrical"), value: "Electrical" },
    { label: trans("Plumbing"), value: "Plumbing" },
    { label: trans("HVAC"), value: "HVAC" },
    { label: trans("Roofing"), value: "Roofing" },
    { label: trans("Flooring"), value: "Flooring" },
    { label: trans("Painting"), value: "Painting" },
    { label: trans("Landscaping"), value: "Landscaping" },
  ];

  // Add "Select All" option
  const allTradeOptions = [
    { label: trans("Select All"), value: "SELECT_ALL" },
    ...tradeOptions,
  ];

  const handleTradeChange = (selectedValues) => {
    if (!selectedValues) {
      setFieldValue("trade", []);
      return;
    }

    if (selectedValues.includes("SELECT_ALL")) {
      // If "Select All" is selected, select all trades (excluding SELECT_ALL)
      const allTrades = tradeOptions.map((opt) => opt.value);
      setFieldValue("trade", allTrades);
    } else {
      // Remove SELECT_ALL if it exists and user is deselecting
      const filteredValues = selectedValues.filter(
        (val) => val !== "SELECT_ALL"
      );
      setFieldValue("trade", filteredValues);
    }
  };

  const handleFileSelect = (files) => {
    setNewAttachments(files);
    setFieldValue("attachments", files);
  };

  return (
    <div className="form-section">
      <div className="row">
        <div className="col-lg-6">
          <Input
            title={trans("Company Code")}
            type="text"
            placeholder={trans("Enter company code")}
            formstyle="form-input"
            id="code"
            name="code"
            value={values.code}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.code}
            touched={touched.code}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("Company Name")}
            type="text"
            placeholder={trans("Enter company name")}
            formstyle="form-input"
            id="name"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.name}
            touched={touched.name}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("License Number")}
            type="text"
            placeholder={trans("Enter license number")}
            formstyle="form-input"
            id="licenseNumber"
            name="licenseNumber"
            value={values.licenseNumber || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.licenseNumber}
            touched={touched.licenseNumber}
          />
        </div>
        <div className="col-lg-6">
          <InputSelect
            id="status"
            name="status"
            label={trans("Status")}
            placeholder={trans("Select Status")}
            options={statusOptions}
            value={values.status}
            onChange={(val) => setFieldValue("status", val)}
            onBlur={() => setFieldTouched("status", true)}
            errors={errors.status}
            touched={touched.status}
            formstyle="form-input select-z-index"
          />
        </div>
        {/* <div className="col-lg-12">
          <InputSelect
            id="trade"
            name="trade"
            label={trans("Trades")}
            placeholder={trans("Select Trades")}
            options={allTradeOptions}
            value={values.trade || []}
            onChange={handleTradeChange}
            onBlur={() => setFieldTouched("trade", true)}
            errors={errors.trade}
            touched={touched.trade}
            formstyle="form-input select-z-index"
            mode="multiple"
            maxTagCount="responsive"
          />
        </div> */}
        <div className="col-lg-6">
          <Input
            title={trans("Contact Person")}
            type="text"
            placeholder={trans("Enter contact person name")}
            formstyle="form-input"
            id="contactPerson"
            name="contactPerson"
            value={values.contactPerson || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.contactPerson}
            touched={touched.contactPerson}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("Contact Email")}
            type="email"
            placeholder={trans("Enter contact email")}
            formstyle="form-input"
            id="contactEmail"
            name="contactEmail"
            value={values.contactEmail || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.contactEmail}
            touched={touched.contactEmail}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("Contact Phone")}
            type="text"
            placeholder={trans("Enter contact phone")}
            formstyle="form-input"
            id="contactPhone"
            name="contactPhone"
            value={values.contactPhone || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.contactPhone}
            touched={touched.contactPhone}
          />
        </div>
        <div className="col-lg-12">
          <TextAreaInput
            title={trans("Address")}
            placeholder={trans("Enter company address")}
            formstyle="form-input"
            id="address"
            name="address"
            value={values.address || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.address}
            touched={touched.address}
            rows={3}
          />
        </div>
        <div className="col-lg-12 mt-1rem">
          {isEditing && attachments && attachments.length > 0 && (
            <div className="mb-3">
              <label className="form-label">
                {trans("Existing Attachments")}
              </label>
              <EditAttachments attachments={attachments} viewOnly={false} />
            </div>
          )}
          <FileUploader
            onFileSelect={handleFileSelect}
            file={newAttachments}
            multiple={true}
            label={trans("Attachments")}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyFormBody;
